import Vue from 'vue'
import { mapState, mapActions } from 'vuex'
import { formatPrice, set, unset } from 'utils/general'
import select from 'dom-select'
Vue.component('product-engraving', resolve => {
  Promise.all([
  ]).then(() => resolve({
    computed: {
      ...mapState('product', [
        'engravingText'
      ]),
      hasConfirmedEngraving () {
        return !!this.engravingText
      },
      showLegacyActions () {
        return this.$el.dataset.isRedesign !== 'true'
      },
      engravingFee () {
        return formatPrice(__GLOBAL__.engravingItem.price)
      },
      engravingFeeDisplay () {
        return `+${this.engravingFee}`
      }
    },
    data () {
      return {
        text: '',
        open: false,
        maxChars: 10
      }
    },
    mounted () {
      const maxChars = parseInt(this.$el.dataset.engravingMaxChars, 10)

      if (!Number.isNaN(maxChars) && maxChars > 0) {
        this.maxChars = maxChars
      }

      this.text = this.engravingText || ''
    },
    watch: {
      open: {
        handler () {
          const formWrapper = select('.product-info__container')
          if (this.open) {
            formWrapper.style.position = 'relative'
          } else {
            formWrapper.style.position = 'sticky'
          }
        }
      },
      engravingText: {
        handler (value) {
          this.text = value || ''
        }
      }
    },
    methods: {
      ...mapActions('product', [
        'setEngraving'
      ]),
      hideBar () {
        document.body.style.overflow = 'hidden'
      },
      showBar () {
        document.body.style.overflow = ''
      },
      toggleEngraving () {
        if (!this.open) {
          this.hideBar()
        } else {
          this.showBar()
        }

        this.open = !this.open
      },
      setText (e) {
        const text = e.target.value

        if (text.length > this.maxChars) {
          return false
        }
        this.text = text
      },
      confirmEngraving () {
        this.setEngraving(this.text)
        this.open = false
        this.showBar()
      },
      resetEngraving () {
        this.text = ''
        this.setEngraving('')
        this.open = false
        this.showBar()
      }
    }
  }))
})
